import { PlatformID } from '@common/clients/api';

export const optaEnabledByPlatform: { [key in PlatformID]?: true } = {
    [PlatformID.VI]: true,
    [PlatformID.VP]: true,
};
